// Virtual sources/settings are separate from graph serialization and can never become real inbox IDs.
export const simulationExample = trigger => {
  const nodes = { end: { type: 'exit' } };
  ['max', 'telegram', 'sms'].forEach((channel, index, channels) => {
    const next = channels[index + 1] ? `${channels[index + 1]}_check` : 'end';
    nodes[`${channel}_check`] = {
      type: 'availability',
      channel,
      source_mode: 'appointment',
      next_available: `${channel}_message`,
      next_unavailable: next,
      next_unknown: 'end',
    };
    nodes[`${channel}_message`] = {
      type: 'message',
      channel,
      source_mode: 'appointment',
      template_id: null,
      success_on: 'accepted',
      timeout_minutes: 30,
      ttl_hours: 0,
      next_success: 'end',
      next_unavailable: next,
      next_unknown: 'end',
      next_failed: next,
      next_timeout: 'end',
    };
  });
  return {
    trigger: {
      ...trigger,
      type: 'mres3',
      entity: 'appointments',
      event: 'created',
    },
    graph: { version: 2, start: 'max_check', nodes },
  };
};

export const simulationFields = graph => {
  const found = new Map();
  const add = (source, field) => {
    if (
      field &&
      [
        'appointment',
        'event',
        'previous',
        'patient',
        'appointment_service',
      ].includes(source)
    )
      found.set(`${source}:${field}`, { source, field });
  };
  const computed = field => {
    const dependencies = {
      minutes_until_appointment: ['planned_start_at'],
      minutes_since_appointment_end: ['planned_end_at'],
      minutes_since_created: ['created_at'],
      minutes_created_before_appointment: [
        'mis_created_at',
        'planned_start_at',
      ],
    };
    (dependencies[field] || []).forEach(name => add('appointment', name));
  };
  Object.values(graph.nodes || {}).forEach(node => {
    (node.definition?.rules || []).forEach(rule => {
      if (rule.source === 'computed') computed(rule.field);
      else add(rule.source, rule.field);
      if (rule.op === 'changed') add('previous', rule.field);
    });
    if (node.type === 'wait' && node.mode === 'dynamic')
      add(node.source, node.field);
  });
  return [...found.values()];
};
